import { Brand, MobileVariant, StepperVariant } from "../types";
import { ComplexWrapper, ContentContainer, ContentWrapper, StepsWrapper, } from "./styled";
import React from "react";
import { CoopIcon } from "@storebrand-digital/coop-icons";
import { Icon } from "@storeblocks/icon";
import { StepItem } from "../StepItem";
import { VerticalLine } from "../styled";
import { useMediaQuery } from "./hooks";
export const Stepper = ({ stepCompleteIcon, disableUpcomingSteps, disableNavigation, children, currentStep, desktopAlign = "left", desktopContentWidth, handleNavigate, steps, mobileVariant = MobileVariant.HORIZONTAL_LINE, branding = Brand.DEFAULT, iconName, }) => {
    const isMobileLayout = useMediaQuery("(max-width: 768px)");
    const stepItem = (step, index) => (React.createElement(StepItem, { key: step.id, step: step, currentStep: currentStep, stepCompleteIcon: stepCompleteIcon, stepperVariant: StepperVariant.DYNAMIC, disableUpcomingSteps: disableUpcomingSteps, disableNavigation: disableNavigation, handleNavigate: handleNavigate, stepNumber: index + 1, lastStep: index === steps.length - 1, mobileVariant: mobileVariant, isMobileLayout: isMobileLayout, branding: branding }));
    const renderAllSteps = () => steps.map((step, index) => stepItem(step, index));
    const renderStepsBeforeCurrentStep = () => steps.reduce((acc, step, index) => {
        if (index <= steps.indexOf(currentStep)) {
            acc.push(stepItem(step, index));
        }
        return acc;
    }, []);
    const renderStepsAfterCurrentStep = () => steps.reduce((acc, step, index) => {
        if (index > steps.indexOf(currentStep)) {
            acc.push(stepItem(step, index));
        }
        return acc;
    }, []);
    const renderIcon = () => {
        if (iconName) {
            return branding !== Brand.COOP ? (React.createElement(Icon, { name: iconName })) : (React.createElement(CoopIcon, { name: iconName }));
        }
    };
    return (React.createElement(ComplexWrapper, { "$steps": steps, "$currentStep": currentStep, "$desktopAlign": desktopAlign },
        isMobileLayout && renderStepsBeforeCurrentStep(),
        !isMobileLayout && (React.createElement(StepsWrapper, null,
            React.createElement("div", { className: "icon-box" }, renderIcon()),
            renderAllSteps())),
        React.createElement(ContentContainer, { id: "content-container", "$percentWidth": desktopContentWidth, "$mobileVariant": mobileVariant },
            isMobileLayout && mobileVariant === MobileVariant.VERTICAL_LINE && (React.createElement(VerticalLine, { "$hasMinHeight": false, "$active": false, branding: branding })),
            React.createElement(ContentWrapper, { "$mobileVariant": mobileVariant }, children)),
        isMobileLayout && renderStepsAfterCurrentStep()));
};
//# sourceMappingURL=index.js.map